import { Box, Flex, FloraTypography } from '@grupoboticario/flora-react'

import { PREVIEW_LABELS } from '@/constants/eventPreviewLabels'

import DateTimeDisplay from './DateTimeDisplay'
import { EventDayPreviewItemProps } from './EventDayPreviewItem.types'
import {
  eventDayTitleStyle,
  eventDayContainerStyle,
  eventDayLabelStyle,
  eventDayValueStyle,
  fieldRowStyle,
  dividerStyle
} from './styles'

const EventDayPreviewItem = ({ day, index, pointsPerTicket, isLast }: EventDayPreviewItemProps) => {
  const getDisplayValue = (value: number | null) => {
    return value != null && String(value) ? value : PREVIEW_LABELS.NO_INFO
  }

  return (
    <>
      <Box css={eventDayContainerStyle}>
        <FloraTypography css={eventDayTitleStyle} fontSize="bodyLargeStandard" fontWeight="medium">
          {PREVIEW_LABELS.DAY_LABEL(index)}
        </FloraTypography>

        <DateTimeDisplay date={day.date} time={day.startTime} />

        <Flex css={fieldRowStyle} align="center">
          <FloraTypography css={eventDayLabelStyle} fontSize="bodyLargeStandard" fontWeight="medium">
            {PREVIEW_LABELS.FIELD_TICKET_QUANTITY}
          </FloraTypography>
          <FloraTypography css={eventDayValueStyle} fontSize="bodyLargeStandard">
            {getDisplayValue(day.ticketQuantity)}
          </FloraTypography>
        </Flex>

        <Flex css={fieldRowStyle} align="center">
          <FloraTypography css={eventDayLabelStyle} fontSize="bodyLargeStandard" fontWeight="medium">
            {PREVIEW_LABELS.FIELD_LIMIT_PER_CPF}
          </FloraTypography>
          <FloraTypography css={eventDayValueStyle} fontSize="bodyLargeStandard">
            {getDisplayValue(day.limitPerCpf)}
          </FloraTypography>
        </Flex>

        <Flex css={fieldRowStyle} align="center">
          <FloraTypography css={eventDayLabelStyle} fontSize="bodyLargeStandard" fontWeight="medium">
            {PREVIEW_LABELS.FIELD_REDEMPTION}
          </FloraTypography>
          <FloraTypography css={eventDayValueStyle} fontSize="bodyLargeStandard">
            {pointsPerTicket ? PREVIEW_LABELS.POINTS_LABEL(pointsPerTicket) : PREVIEW_LABELS.NO_INFO}
          </FloraTypography>
        </Flex>
      </Box>

      {!isLast && <Box css={dividerStyle} data-testid="event-day-divider" />}
    </>
  )
}

export default EventDayPreviewItem
